import moment from 'moment'

const usefull = {

    HumanformatDate : (dateString)=>{
        dateString = moment(dateString).format('DD/MM/YYYY')
        const dateParts = dateString.split('/');
        const date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = date.toLocaleDateString('fr-FR', options);
      
        return formattedDate;
      },
}

export default usefull;